interface EarlyWarningProps {
  color?: string;
  fillColor?: string;
  bgColor?: string;
  size?: string;
  title: string;
  content: string;
  render?: () => React.ReactNode;
  [propName: string]: any;
}

export const EarlyWarningView: React.FC<EarlyWarningProps> = ({
  color = "var(--app-text-33)",
  fillColor = "var(--app-text-34)",
  bgColor = "var(--app-bg-41)",
  size = "20px",
  title,
  content,
  render = () => <SvgIcon name="svg03" />,
  AlertID = 0,
  ...args
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <a
      className="font-500 text-12 w-full flex justify-between items-center p-[8px_16px] rounded-8"
      style={{ backgroundColor: bgColor }}
      {...args}
      rel="noreferrer"
      onClick={e => {
        e.preventDefault();
        if (!window?.AndroidInterface?.getOnClient) {
          if (pathname.startsWith("/daily")) {
            const dailyDetailPath = "/daily/alertdetail";
            navigate(dailyDetailPath);
          }
          if (pathname.startsWith("/hourly")) {
            const hourlyDetailPath = "/hourly/alertdetail";
            navigate(hourlyDetailPath);
          }
        }
      }}
    >
      <div className="flex justify-start items-center gap-x-16">
        <AlertSvg color={fillColor} size={size} />
        <div className="flex flex-col items-start gap-y-5">
          <div className="font-bold" style={{ color }}>
            {title}
          </div>
          <div className="color-[var(--app-text-04)] font-300">{content}</div>
        </div>
      </div>
      {render()}
    </a>
  );
};
